var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._b({class:['totem-input', _vm.size, { 'squared': _vm.squared }],style:(_vm.cssVars),attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":_vm.handleInput}},'input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }